import _ from 'lodash';
import { ref } from 'vue';
import { inject, provide } from 'vue';

const key = Symbol('rich-text-ai-format');

/**
 * 富文本AI格式化提供器
 * 在外部组件中使用，提供 AI 格式化函数的加载状态
 * @returns {Object} 包含 loading 状态的对象
 */
export function useRichTextAiFormatProvide() {
  const loading = ref(false);
  let loadingCount = 0;

  provide(key, {
    setLoading() {
      loadingCount++;
      loading.value = !!loadingCount;
    },
    resetLoading() {
      loadingCount--;
      loading.value = !!loadingCount;
    }
  });

  return { loading };
}

/**
 * 注入富文本 AI 格式化函数的加载状态
 * 在内部组件中使用，用于更新加载状态
 * @returns {Object} 包含 setLoading 和 resetLoading 方法的对象
 */
export function useRichTextAiFormatInject() {
  const { setLoading, resetLoading } = inject(key, {
    setLoading: _.noop,
    resetLoading: _.noop
  });

  return { setLoading, resetLoading };
}
